// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7JZsz","content":"styles_content__X7RYr","tableWrap":"styles_tableWrap__2JLF_"};